import { RoutesEnum } from '~/constants/enums';
import { StepType } from '~addListing/types';

export const addListingStepsData: StepType[] = [
  {
    id: 1,
    title: 'basicInfo',
    url: `/${RoutesEnum.INITIALIZE}`,
  },
  {
    id: 2,
    title: 'listingDetails',
    url: `/${RoutesEnum.DETAILS}`,
  },
  {
    id: 3,
    title: 'listingPrice',
    url: `/${RoutesEnum.PRICE}`,
  },
  {
    id: 4,
    title: 'listingDescription',
    url: `/${RoutesEnum.EDIT}`,
  },
  {
    id: 5,
    title: 'photosVideos',
    url: `/${RoutesEnum.PHOTOS}`,
  },
  {
    id: 6,
    title: 'publish',
    url: `/${RoutesEnum.PUBLISH}`,
  },
];

export const PAYMENT_METHOD_CASH_KEY = 1;
export const PAYMENT_METHOD_INSTALLMENT_KEY = 4;
export const PAYMENT_METHOD_CASH_AND_INSTALLMENT_KEY = 3;

export const MONTHLY_DURATION = 30;
export const YEARLY_DURATION = 360;
export const WEEKLY_DURATION = 7;
export const DAILY_DURATION = 1;
export const RESALE_ID = 2;
